import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "Sweep" */ './lazyIndex'),
    {
        name: 'Sweep',
    }
);

export const lazyShowSweepDialog: LazyAction<typeof lazyIndex.showSweepDialog, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.showSweepDialog);
